/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChipDto } from '../../models/chip-dto';

export interface GetAllAvailableChips$Json$Params {
}

export function getAllAvailableChips$Json(http: HttpClient, rootUrl: string, params?: GetAllAvailableChips$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllAvailableChips$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChipDto>>;
    })
  );
}

getAllAvailableChips$Json.PATH = '/v1/chips/available';
